
























































import { Vue, Component, Prop } from 'vue-property-decorator'
import { baseUrl } from '@/util/Helpers'

@Component({ name: 'share-link-modal' })
export default class ShareLinkModal extends Vue {
    @Prop({ type: String, required: true })
    linkId!: string

    @Prop({ type: String, required: true })
    linkKey!: string

    @Prop({ type: Number, required: true })
    viewCount!: string

    get link(): string {
        return `${baseUrl()}#/share/${this.linkId}/${this.linkKey}`
    }
}
